import {ValidationMessage} from 'common';
import {SelectField, SelectFieldProps} from 'evergreen-ui';
import React, {memo} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {Referral} from 'referral';
import {Observable} from 'rxjs';
import {useObservable} from 'rxsupport';
import {OfferFormInput} from './OfferForm';
import {ServiceLocationTypeMap} from "../domain/types";

type ServiceLocationTypeInputProps = {
    fieldName: 'serviceLocationType' |
        'serviceLocationParaprofessionalType' |
        'serviceLocationMidLevelType' |
        'serviceLocationHighLevelType' |
        'serviceLocationGroupCareType';
    referral: Referral;
    isRequired?: boolean;
    isSubmitting$: Observable<boolean>;
    permittedLocations?: string[];
} & SelectFieldProps;


const defaultLocationsPermitted = Array.from(ServiceLocationTypeMap.keys());

export const ServiceLocationTypeInput = memo(({
                                                  fieldName,
                                                  referral,
                                                  isSubmitting$,
                                                  permittedLocations = defaultLocationsPermitted,
                                                  isRequired = true,
                                                  ...selectProps
                                              }: ServiceLocationTypeInputProps) => {
    const {
        control,

        formState: {
            errors,
        },
    } = useFormContext<OfferFormInput>();

    const sending = useObservable(isSubmitting$, false);

    return (
        <Controller
            name={fieldName}
            control={control}
            rules={{
                required: {
                    message: 'This field is required.',
                    value: isRequired,
                },
            }}
            render={({field: {onChange, value}}) => {
                const props = {
                    maxWidth: '24em',
                    label: 'Service Location',
                    // Several of these selects can carry the same label on one form, so the
                    // field name is what tells them apart. SelectField puts this id on both
                    // the select and the label's htmlFor.
                    id: fieldName,
                    ...selectProps,
                    onChange,
                    value: value ? value : undefined,
                    isInvalid: !!errors[fieldName],
                    validationMessage: <ValidationMessage error={errors[fieldName]}/>,
                    disabled: sending,
                }
                return (
                    <SelectField {...props}>
                        <option value=''/>
                        {
                            Array.from(ServiceLocationTypeMap.keys())
                                .filter(key => permittedLocations.includes(key))
                                .map(key => <option key={key}
                                                    value={key}>
                                    {ServiceLocationTypeMap.get(key)}
                                </option>)
                        }
                    </SelectField>
                );
            }}
        />
    );
});